import React, { FC } from "react";

import { IconProps } from "..";

import "../Icon.css";

export const IconBrain: FC<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className="Icon IconBrain"
  >
    <path d="M13.21 6.25c-.33.005-.585.294-.585.624v7.501c0 .688.558 1.248 1.245 1.249l-.002 1.25a2.46 2.46 0 01-1.243-.347v1.576c0 .31.226.583.533.622a3.428 3.428 0 003.762-2.748 3.703 3.703 0 001.33-2.852c0-.878-.318-1.708-.857-2.364a4.364 4.364 0 01-1.724 2.26l-.692-1.04a3.118 3.118 0 001.357-2.124 2.869 2.869 0 00-.013-1.037 3.212 3.212 0 00-1.878-2.318 3.012 3.012 0 00-1.232-.252zm-2.433.015a3.09 3.09 0 00-2.236.9 3.089 3.089 0 00-.91 2.316c0 .014.002.025.003.038.006.115.016.23.035.345h-.001a3.12 3.12 0 001.355 2.116l-.691 1.04a4.363 4.363 0 01-1.724-2.26 3.703 3.703 0 00.471 5.216 3.428 3.428 0 003.763 2.749.622.622 0 00.533-.622v-3.452c-.368.216-.79.347-1.246.348l-.003-1.25c.688 0 1.246-.56 1.245-1.249h.004V6.892a.62.62 0 00-.598-.627z" />
  </svg>
);
